import React from 'react'
import { Hugeicon } from './Hugeicon'
import { HugeiconKey } from './hugeicons'

export type IconGlyphColor = 'white' | 'silver' | 'grey' | 'red' | 'green' | 'blue' | 'yellow' | 'purple' | 'darkblue'

type Props = Omit<React.HTMLAttributes<HTMLElement>, 'color'> & {
  name: HugeiconKey
  color?: IconGlyphColor
}

// A Hugeicon where the icon font's <i class="icon-…"> used to be (CVL-87): the same <i> wrapper,
// so the page CSS that places and sizes those icons still applies, with the font's spacing and
// color flavors (`color="red"` for the old icon-…-red) from the .hgi rules in scss/_icons.scss.
export const IconGlyph: React.FC<Props> = ({ name, color, className, ...rest }) => (
  <i className={['hgi', color && `-${color}`, className].filter(Boolean).join(' ')} aria-hidden="true" {...rest}>
    <Hugeicon name={name} />
  </i>
)

export default IconGlyph
